import {
  vectorNormalize,
  vectorFromTo,
  getRandomNormal,
} from "./helper/MathHelper";

export const makeEntity = (props) => {
  const defaultProps = {
    position: { x: 0, y: 0 },
    velocity: { x: 0, y: 0 },
    speed: 1,
    face: "bruh",
    edgeBehavior: "die",
    trackBehavior: null,
    killer: false,
    money: 0,
    dead: false,
    key: {},
    id: -1,
    dimension: 0,
  };
  const newEntity = { ...defaultProps, ...props };
  return newEntity;
};

export const makeTransfer = (state, fromId, toId, amount) => {
  const fromLoc = state.locations[fromId];
  const toLoc = state.locations[toId];
  const v = vectorNormalize(vectorFromTo(fromLoc.position, toLoc.position));
  return makeEntity({
    position: fromLoc.position,
    velocity: v,
    edgeBehavior: "die",
    face: "transfer",
    trackBehavior: null,
    transferTarget: toId,
    transferRadius: 30,
    speed: 2.2,
    money: amount,
    dimension: 40,
  });
};

export const makeAgent = (state, locId) => {
  const loc = state.locations[locId];
  const velocity = getRandomNormal();

  return makeEntity({
    position: loc.position,
    speed: 2.4,
    velocity: velocity,
    edgeBehavior: "bounce",
    face: "smith",
    trackBehavior: "seekanddestroy",
    trackingState: { state: "idle", sleep: false },
    trackingSleep: 6000,
    destroyRadius: 25,
    seekRadius: 70,
    raidRadius: 10,
    raidMod: 1.0,
    dimension: 40,
  });
};
